module.exports = __webpack_public_path__ + "img/primarySlot.5131e4ea.png";